import React, { useState } from 'react'
import FailPassCodesWidgetContainer from './FailPassCodesWidgetContainer';
import StatusWidgetContainer from './StatusWidgetContainer';
import styles from './StatusContainer.module.scss';
import BaseButton from 'components/ui_components/buttons/BaseButton'
import ConfirmModal from 'components/ui_components/modals/ConfirmModal'
import { compose } from 'redux'
import withModal from 'withModal'
import dataProvider, { POST } from 'providers/dataProvider'
import ProgressBar from 'components/ui_components/ProgressBar/ProgressBar'
import authStorage from 'providers/authStorage.js'
import { userRoles } from 'config/userRoles'
import { useNavigate } from 'react-router-dom'

const baseStyles = `
    font-size: 13px;
    border-radius: 5px;
    padding: 10px 25px;
    transition: opacity .5s;
    background-color: #004C6A !important;
    color: white !important;
  `;

const StatusContainer = (props) => {
  const {
    modalOpen,
    handleOpenModal,
    handleCloseModal,
    modalID,
    reqID,
    reqStatusCode,
    reqBillStatusDesc,
    handleRequisitionUpdate
  } = props;
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Get current user role code to check if user is sales role
  const userRoleCode = authStorage.getAccess()?.userRoleCode;
  return (
    <>
      {loading && <ProgressBar />}
      <ConfirmModal
        title="Duplicated requisition will be treated as separate independent requisition. Are you sure you want to duplicate this requisition?"
        message=""
        modalIsOpen={modalOpen && modalID === "requisitionDuplicateModal"}
        handleCloseModal={handleCloseModal}
        handleSubmit={() => {
          setLoading(true);
          dataProvider(POST, `requisitions/${reqID}/copy`, {})
            .then((d) => {
              setLoading(false);
              navigate(`/requisitions/${d.data.id}/show`);
            })
          handleCloseModal();
        }}
      />
      <div className={styles.root}>
        <FailPassCodesWidgetContainer reqID={reqID} />
        <StatusWidgetContainer
          reqID={reqID}
          reqStatusCode={reqStatusCode}
          reqBillStatusDesc={reqBillStatusDesc}
          handleRequisitionUpdate={handleRequisitionUpdate}
        />
      </div>
      <div className={styles.root}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {userRoleCode !== userRoles.sales && userRoleCode !== userRoles.collaborator && (
            <BaseButton
              themePaletteColor="primary.main"
              defaultStyles={baseStyles}
              onClick={() => handleOpenModal("requisitionDuplicateModal")}
            >
              Duplicate This Requisition
            </BaseButton>
          )}
        </div>
      </div>
    </>
  );
}

export default compose(
  withModal
)(StatusContainer)